import React from 'react';
import './about.css';
import AboutContent from './AboutContent';
import Birthday from '../../svg/Birthday';
import Degree from '../../svg/Degree';
import Person from '../../svg/Person';
import Mail from '../../svg/Mail';
import Call from '../../svg/Call';
import Location from '../../svg/Location';
import SkillList from './SkillList';


function About() {

    const skillList = [
        {
          id:1,
          skill:"Html"
        },
        {
          id:2,
          skill:"Css"
        },
        {
          id:3,
          skill:"Javascript"
        },
        {
          id:4,
          skill:"React"
        },
        {
          id:5,
          skill:"Redux"
        },
    ]

const handleTabClick = () =>{

    const tabs = document.querySelectorAll('[data-tab-target]');
    const tabContents = document.querySelectorAll('[data-tab-content]');

    tabs.forEach(tab =>{
        tab.addEventListener('click', ()=>{
            let target = document.querySelector(tab.dataset.tabTarget);
            
            tabContents.forEach(tabContent =>{
                tabContent.classList.remove('active');
            })

            tabs.forEach(tab=>{
                tab.classList.remove('active');
            })
            
            target.classList.add('active');
            tab.classList.add('active');
        })
    })

}


    return (
        <div className="about" id="about">
            <div className="container">

             <div className="section-flex">

                 <div className="section-left">
                        <div className="about-header-container">
                            <h4>Why hire me for your next Project</h4>
                            <h3>Professional Experience</h3>
                        </div>

                        <div className="img-container">
                            <img src={process.env.PUBLIC_URL + '/image/1.png'} alt="Ashish gupta"/>

                        </div>
                        <img src={process.env.PUBLIC_URL + '/image/icons/dot.png'} className="dotted" alt="Ashish Gupta"/>
                 </div>{/* Section left end */}



                <div className="section-right">
                     
                    <ul className="tabs">
                        <li data-tab-target="#c1" onClick={handleTabClick} className="tab button active">Personal Info</li>
                        <li data-tab-target="#c2" onClick={handleTabClick} className="tab button">Education</li>
                        <li data-tab-target="#c3" onClick={handleTabClick} className="tab button">Skill</li>
                    </ul>
            
                    <div className="tab-content">

                        <section className=" tab-section active" id="c1" data-tab-content>    
                              
                                <div className="content">
                                    <h1 className="title">For over 2+ year I have Sucessfully providing best services to my clients</h1>
                                    <p className="para"> I am Ashish Gupta, a Software Engineer based in Mumbai who brings your visualization in reality and build a website that increase your business. I'm  available for Freelance work and projects.</p>

                                    <div className="section-flex">
                                        <div className="section-left">
                                            <AboutContent Icon={<Person className={"i"}/>} name="Ashish Gupta" />
                                            <AboutContent Icon={<Call className={"i"}/>} name={<a href='tel: 8689868867'> 8689868867</a>} />
                                            <AboutContent Icon={<Mail className={"i"}/>} name={<a href="mailto: ag939431@gmail.com">ag939431@gmail.com</a>} />
                                        </div>{/* col end */}

                                        <div className="section-right">
                                            <AboutContent Icon={<Birthday className={"i"}/>} name="Born on 21 Nov,1999" />
                                            <AboutContent Icon={<Degree className={"i"}/>} name="BCA" />
                                            <AboutContent Icon={<Location className={"i"}/>} name="Malwani Malad west" />
                                        </div>{/* col end */}
                                    </div>
                                </div> 

                                <div className="button">Know more about me</div>

                        </section>
                        {/* ********  About section end  ******** */}
                    
                    
                        <section className=" tab-section" id="c2" data-tab-content>    

                           <div className="wrapper">
                               <div className="center-line"></div>

                               <div className="singlerow row1">
                                   <section>
                                       <div className="details">
                                           <span className="title">BCA</span>
                                           <span> 2017 - 2020</span>
                                       </div>
                                       <p>I had completed my Bachelor Of Computer Application (BCA) from
                                           Atharva College and board was Yashwantrao Chavan Maharashtra Open University (YCMOU).</p>
                                   </section>
                               </div>

                               <div className="singlerow row2">
                                   <section>
                                       <div className="details">
                                           <span className="title">HSC</span>
                                           <span> 2016 - 2017</span>
                                       </div>
                                       <p>I had completed my Higher Secondary (HSC) from The B.S.G.Ds' Junior College with 75% in Commerce Stream and board was Maharashtra Board.</p>
                                       {/* <div className="bottom">
                                           <i> - Famous</i>
                                       </div> */}
                                   </section>
                               </div>

                               <div className="singlerow row1">
                                   <section>
                                       <div className="details">
                                           <span className="title">SSC</span>
                                           <span> 2014 - 2015</span>
                                       </div>
                                       <p>I had completed my Secondary School (SSC) from Ideal English High school with 78.80% and board was Maharashtra Board.</p>
                                   </section>
                               </div>
                           </div>    
                           
                        </section>

                        {/* *****  Education end  ***** */}

                        <section className=" tab-section" id="c3" data-tab-content> 

                           <div className="skill-bar">
                                {skillList.map(skill =>{
                                    return <SkillList key={skill.id} content={skill.skill} />
                                })}
                           </div>                 
                        </section> 
                    </div> {/* *** Skills content ends  **** */}

                 </div>{/* ***  section right end  **** */}
             </div>{/* ***  Section flex end  **** */}
           </div>



        {/* ***********   Amination start   ************* */}

            <img src={process.env.PUBLIC_URL + '/image/icons/line-circle.png'} className="line-circle" alt="Ashish Gupta"/>

            <img src={process.env.PUBLIC_URL + '/image/icons/dot-line.png'} className="dot-line" alt="Ashish Gupta"/>

        </div>
    )
}

export default About;
